import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import { Card } from '../../../app/models/card.model';
import { configurations } from '../../../configurations/configurations';
import { ConfigData } from '../../../app/models/configData.model';
import { SharingDataService } from '../sharingData/sharing-data.service';
import { JsonDetails } from '../../../app/models/jsonDetails.model';


@Injectable({
  providedIn: 'root',
})
export class CardService {

  constructor(@Inject(LOCALE_ID) private language: string) {}

  getRecommendedCardList(nationality: boolean, income: number,incomeUSD: number, cardDetails: Card[]): Card[] {
    let list: Card[] = [];

    if(nationality)
    {
      list = cardDetails.filter(
        (card) =>
          (card.MinIncomeSaudi <= income)
      );
    }
    else
    {
      list = cardDetails.filter(
        (card) =>
          (card.MinIncomeExpat <= income)
      );     
    }
    return list;
  }

  getConfigInfo(): ConfigData {
    return configurations;
  }

  public getLanguage(): string {
    return this.language;
  }

}
